"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.erfDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var erfDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createErf: _factoriesAny.createErf
};
exports.erfDependencies = erfDependencies;